<template>
    <div class="classMeeting commonBackground margin-top">
        <div class="text-right topReminder">
            <el-button type="text" @click="$router.push('/teacher/moral-edu-center/timetable')">
                不知道怎么选？看看德育全年课表
            </el-button>

                <el-tooltip placement="bottom">
                    <div slot="content">
                        <div style="border-bottom: 1px solid #e5e5e5;
                        margin-bottom: 10px;padding-bottom: 10px;">
                            班会课是什么？
                        </div>
                        <div>
                            高招教育网的”班会课“以辅助学<br/>
                            校德育教学为出发点，为学校提供<br/>
                            行为规范养成、 弘扬民族精神、<br/>
                            理想信念教育等主题的丰富的优<br/>
                            质班会课素材，素材包括视频、<br/>
                            音频、图文等形式，帮助班主
                            <br/>任高质高效的开展班会课。
                        </div>
                    </div>
                <el-button class="el-icon-question cursorSz"  type="text">使用指南</el-button>
                </el-tooltip>

        </div>
        <el-tabs v-model="activeName" class="tabs" @tab-click="handleClick">
            <el-tab-pane :label="item.title" :name="item.id" v-for="item in schoolManagement" :key="item.id">
                <div v-show="item.id==='first'">
                    <div class="position-relative condition">
                        <div v-show="!loadingType">
                            <div class="margin-bottom listLine delFloat">
                                <div class="text-medium-secondary">年级：</div>
                                <div class="options" v-for="item in gradeList"
                                     @click="selectGrade(item.gradeId)"
                                     :class="item.gradeId===gradeId?'activelvz':''"
                                     :key="item.gradeId">
                                    {{item.gradeName}}
                                </div>
                            </div>
                            <div class="listLine margin-bottom delFloat">
                                <div class="text-medium-secondary">分类：</div>
                                <div class="options" v-for="items in typeList" @click="selectType(items.categoryId)"
                                     :class="typeFId===items.categoryId?'activelvz':''"
                                     :key="items.categoryId">
                                    {{items.categoryName}}
                                </div>
                            </div>
                            <div v-show="typeSonList.length>0" class="listLine margin-bottom delFloat">
                                <div class="text-medium-secondary">子分类：</div>
                                <div class="options" v-for="item in typeSonList" :class="typeSId===item.categoryId?'activelvz':''" :key="item.categoryId" @click="selectSonType(item.categoryId)">
                                    {{item.categoryName}}
                                </div>
                            </div>
                        </div>
                        <loading :show="loadingType" icon-width="30px" icon-height="30px"></loading>
                    </div>
                    <div class="position-relative contentBoxF">
                        <div v-show="!loadingData&&classMeetingList.length>0" class="contentBox delFloat">
                            <div class="sonBox border " v-for="item in classMeetingList" :key="item.id" @click="selectClassMeeting(item.id)">
                                <div>
                                    <img v-lazy="item.coverImgUrl" :key="item.coverImgUrl" alt="">
                                </div>
                                <div class="text-ellipsis name text-default-color" :title="item.name">
                                    {{item.name}}
                                </div>
                                <div class="description text-small-secondary" :title="item.description">
                                    {{item.description}}
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <el-pagination background

                                           layout="total, prev, pager, next, jumper"
                                           :page-size="20"
                                           :total="totalItem"
                                           :current-page.sync="currentPage"
                                           @current-change="handlerPage">
                            </el-pagination>
                        </div>
                        <empty v-show="!loadingData&&classMeetingList.length<1" :text-size="18" class="margin-medium-top"></empty>
                        <loading :show="loadingData"></loading>
                    </div>
                </div>
                <div v-show="item.id==='second'">

                </div>
            </el-tab-pane>
        </el-tabs>
        <common-target-router @clearHref="clearHref" :get-location="getLocation"></common-target-router>
    </div>
</template>

<script>
    import {classMeetingCategory, classMeetingGrade, classMeetingList} from "../../../config";
    export default {
        name: "classMeeting",
        data(){
            return{
                getLocation:'',
                gradeList:[],
                gradeId:'',
                typeList:[],
                typeDefaultId:'',
                typeFId:'',
                typeSId:'',
                typeSonList:[],
                activeName:'first',
                schoolManagement:[
                    {id:'first',title:'班会课'}
                ],
                currentPage:1,
                totalItem:0,
                classMeetingList:[],
                loadingType:true,
                loadingData:true
            }
        },
        mounted(){
          this.searchGrade();
        },
        methods:{
            handleClick(val){
                this.activeName=val.name;
            },
            handlerPage(){
                this.searchClassMeetingData();
            },
            //查出年级
            async searchGrade(){
                let result=await classMeetingGrade();
                if(result.status){
                    this.gradeList=result.data;
                    console.log(result.data);
                    this.gradeId=result.data[0].gradeId;
                    this.searchType();
                }
            },
            //查出分类
            async searchType(){
                let result=await classMeetingCategory();
                if(result.status){
                    this.loadingType=false;
                    let zhi=result.data.unshift({
                        categoryId:'',
                        categoryName:'全部',
                        typeId:1,
                        children:[]
                    })
                    this.typeList=result.data;
                    console.log('我是分类');
                    console.log(result.data);
                    this.typeDefaultId=result.data[0].typeId;
                    // this.typeSId=result.data[0].children[0].categoryId;
                    this.searchClassMeetingData();
                }else{
                    this.loadingType=false;
                }
            },
            //选择年级
            selectGrade(val){
                this.currentPage=1;
                this.gradeId=val;
                this.searchClassMeetingData();
            },
            //选择类型
            selectType(val){
                this.currentPage=1;
                this.typeFId=val;
                let zhi=this.typeList.filter((valSon)=>{
                    return val===valSon.categoryId;
                });
                this.typeSonList=zhi[0].children;
                console.log(this.typeSonList);
                if(zhi[0].children.length>0){
                    this.typeSId=zhi[0].children[0].categoryId;
                }else{
                    this.typeSId='';
                }
                this.searchClassMeetingData();
            },
            //选择子类型
            selectSonType(val){
                this.currentPage=1;
                this.typeSId=val;
                this.searchClassMeetingData();

            },
            //查出班会内容列表
            async searchClassMeetingData(){
                this.loadingData=true;
                let categoryId='';
                if(this.typeSId!==''){
                    categoryId=this.typeSId;
                }else{
                    categoryId=this.typeFId;
                }
                let result=await classMeetingList(this.gradeId,categoryId,this.typeDefaultId,this.currentPage,20);
                if(result.status){
                    this.loadingData=false;
                    this.totalItem=result.data.totalRecords;
                    console.log('我是班会内容');
                    this.classMeetingList=result.data.data;
                    console.log(this.classMeetingList);
                }else{
                    this.loadingData=false;
                }
            },
            clearHref(){
              this.getLocation='';
            },
            selectClassMeeting(val){
                const {href}=this.$router.resolve({path:'/classMeetingDetail',query:{id:val}});
                this.getLocation=href;
            }

        }
    }
</script>

<style lang="scss" scoped>
    .classMeeting{
        padding:0 20px 20px 20px;
        .tabs{

            .condition{
                min-height:50px;
            }
            .contentBoxF{
                min-height: 300px;
                height:auto;
            }
            .listLine{
                >div{
                    float: left;
                }
                >div.options:hover{
                    animation:commonOption .4s ease-out forwards;
                }
                >div.options{
                    margin-right: 10px;
                    padding:0 5px 0 5px;
                    border-radius: 3px;
                   cursor: pointer;
                }
            }
            .contentBox{
                padding:30px 0 50px 20px;
                .sonBox{
                    cursor: pointer;
                    float: left;
                    width:224px;
                    height:238px;
                    margin: 0 16px 16px 0;
                    padding-bottom: 16px;
                    img{
                        width:100%;
                        height: 126px;
                    }
                    .name{
                        padding: 0 16px;
                        margin: 8px 0;
                    }
                    .description{
                        padding: 0 16px;
                        -webkit-line-clamp: 3;
                        overflow: hidden;
                        line-height: 20px;
                        text-overflow:ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        font-size: .85em;
                    }
                }
                .sonBox:hover{
                    animation: commOptionHotJob .4s ease-out forwards;
                }
            }

        }
    }
</style>
